"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  fill: "#12B7F5",
  d: "M12 3.75a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 1 0 0-16.5m4.644 11.893c-.258.032-.996-1.168-.996-1.168a3.1 3.1 0 0 1-1.128 2.255c.309.086.603.219.871.394.206.151.18.305.144.368-.162.274-2.781.175-3.535.09-.756.083-3.373.181-3.535-.09-.04-.062-.061-.216.141-.368.269-.175.563-.308.871-.394a3.1 3.1 0 0 1-1.132-2.255s-.742 1.213-.984 1.172c-.125-.014-.281-.655.202-2.207.102-.325.239-.707.378-1.069l.487-1.273v-.404c0-2.176 1.027-4.367 3.555-4.366s3.557 2.189 3.557 4.366v.404l.511 1.273.391 1.065c.477 1.552.321 2.193.202 2.207"
}), 'QqRing');
